<app-custom-spinner *ngIf="isLoading"></app-custom-spinner>

<div (click)="closeDialog()" class="ns-close-button"></div>
<div class="items-container">
  <div *ngFor="let project of projects" class="item-grid">
    <div class="image-name-grid">
      <a [routerLink]="['/', currentLanguage, RouterUrls.BrowseProjects, project.slug]" (click)="closeDialog()" class="image">
        <div [style.backgroundImage]="'url(' + project.picture_thumbnail + ')'"></div>
      </a>
      <a [routerLink]="['/', currentLanguage, RouterUrls.BrowseProjects, project.slug]" (click)="closeDialog()" class="name">{{ project.name[currentLanguage] }}</a>
    </div>
    <div class="advance-block">
      <div class="heading">{{'IMPACT_PAGE.advance_impactpage' | translate}}</div>
      <div class="amount" *ngIf="!project.square_meters">{{ project.progress | ceil }}</div>
      <div class="amount" *ngIf="project.square_meters">{{ project.progress * 10000 | ceil }}</div>
      <div class="message" *ngIf="!project.square_meters">{{ project.main_kpi_unit[currentLanguage] }}</div>
      <div class="message" *ngIf="project.square_meters">{{ project.square_meters_unit[currentLanguage] }}</div>
    </div>
  </div>
</div>
